// src/pages/consult/step3.js

import React, { useState, useEffect } from 'react';
import AuthService from '../../services/AuthService';
import styles from './consult.module.css';

function Step3Estado({ onComplete, onBack }) {
    const [estados, setEstados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        setLoading(true);
        AuthService.fetchEstados()
            .then(data => {
                const ordenados = [...data].sort((a, b) => {
                    // SP sempre primeiro
                    if (a.sigla === 'SP') return -1;
                    if (b.sigla === 'SP') return 1;

                    // resto em ordem alfabética
                    return a.sigla.localeCompare(b.sigla, 'pt-BR');
                });

                setEstados(ordenados);
                setLoading(false);
                })
            .catch(err => {
                setError('Falha ao carregar estados: ' + err.message);
                setLoading(false);
            });
    }, []);

    if (loading) return <div>Carregando...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div className={styles.consultPage}>
            <h4>Escolha o Estado</h4>
            {estados.map(estado => (
                <button key={estado.sigla} onClick={() => onComplete(estado.sigla)}>
                    {estado.sigla}
                </button>
            ))}
            <button className={styles.backButton} onClick={onBack}>Voltar</button>
        </div>
    );
}

export default Step3Estado;
